import { useMemo } from 'react'
import { sortBy, map, groupBy } from 'lodash'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data?.length) return data

    return sortBy(
      map(groupBy(data, 'appointment_type_id'), group => {
        let appointment_type = group[0].appointment_type
        return {
          id: appointment_type._id,
          text: appointment_type.display_name,
        }
      }),
      'text'
    )
  }, [data])
}
